import * as i0 from '@angular/core';
import { Injectable, Inject, NgModule } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpErrorResponse, HttpHeaders, HttpClientModule } from '@angular/common/http';
import { __decorate, __metadata } from 'tslib';
import { throwError, of } from 'rxjs';
import { catchError, tap, map } from 'rxjs/operators';
import * as i2 from '@ngrx/store';
import { StoreModule, createSelector } from '@ngrx/store';
import * as i2$1 from '@ngrx/store-devtools';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { CommonModule } from '@angular/common';

var BRANDS;
(function (BRANDS) {
    BRANDS["SUPERCLUB"] = "superclub";
    BRANDS["DAVIVIENDA"] = "davivienda";
    BRANDS["ICBCMALL"] = "icbcmall";
})(BRANDS || (BRANDS = {}));
var CONVERSION_TYPES;
(function (CONVERSION_TYPES) {
    CONVERSION_TYPES["CURRENCY_BY_CREDIT"] = "CURRENCY_BY_CREDIT";
    CONVERSION_TYPES["CREDIT_BY_CURRENCY"] = "CREDIT_BY_CURRENCY";
})(CONVERSION_TYPES || (CONVERSION_TYPES = {}));
var SITES;
(function (SITES) {
    SITES["ARG"] = "ARG";
    SITES["COL"] = "COL";
    SITES["BRA"] = "BRA";
    SITES["MEX"] = "MEX";
})(SITES || (SITES = {}));
var Site;
(function (Site) {
    Site["ARG"] = "ARG";
    Site["COP"] = "COL";
    Site["MXN"] = "MEX";
    Site["BRL"] = "BRA";
})(Site || (Site = {}));
var Environment;
(function (Environment) {
    Environment["DEV"] = "development";
    Environment["ST"] = "staging";
    Environment["PROD"] = "production";
    Environment["LOCAL"] = "local";
})(Environment || (Environment = {}));
var ProductTypes;
(function (ProductTypes) {
    ProductTypes["Airline"] = "FLIGHT";
    ProductTypes["Hotel"] = "HOTEL";
    ProductTypes["Activity"] = "ACTIVITY";
    ProductTypes["Insurance"] = "HEALTH_INSURANCE";
    ProductTypes["Package"] = "PACKAGE";
    ProductTypes["Car"] = "CAR";
    ProductTypes["Multiproduct"] = "MULTIPRODUCT";
})(ProductTypes || (ProductTypes = {}));
var actionEnum;
(function (actionEnum) {
    actionEnum[actionEnum["add"] = 0] = "add";
    actionEnum[actionEnum["reduce"] = 1] = "reduce";
})(actionEnum || (actionEnum = {}));

function Builder(constructor) {
    return class extends constructor {
        builder() {
            const properties = Object();
            const nameBuild = 'build';
            const builder = new Proxy(Object(), {
                get(_, prop) {
                    if (prop === nameBuild) {
                        return () => ({
                            ...new constructor(),
                            ...properties
                        });
                    }
                    return value => {
                        properties[prop] = value;
                        return builder;
                    };
                }
            });
            return builder;
        }
    };
}

/**
 *
 */
let Base = class Base {
    builder() { }
    /**
     *
     */
    constructor() { }
};
Base = __decorate([
    Builder,
    __metadata("design:paramtypes", [])
], Base);
class Conversion extends Base {
}
class Reward extends Base {
}
class RewardSession extends Base {
    constructor(reward) {
        super();
        // tslint:disable-next-line: no-use-before-declare
        this.slider = new Slider(reward);
    }
}
class RewardSessionServer {
    constructor(reward) {
        // tslint:disable-next-line: no-use-before-declare
        this.slider = new Slider(reward);
    }
}
class CreditsRewards extends Base {
}
// tslint:disable-next-line: no-namespace
class Product extends Base {
}
class Slider extends Base {
    constructor(reward) {
        super();
        this.points = reward.value;
        this.selectedPoints = reward.value;
        this.CONVERSION_FACTOR = reward.conversion.conversion_factor;
        this.CONVERSION_RATE_TYPE = reward.conversion.conversion_rate_type;
    }
}
class ProductsSession extends Base {
}
class Source extends Base {
}
class Products extends Base {
}
class AvailabilityRewards extends Base {
}
class PriceRewards extends Base {
}
class TaxesRewards extends Base {
}
class AllianceMenuItem extends Base {
}
class ComponentErrorHandler extends Base {
}
class AlliancesError extends Base {
}

var AlliancesActions;
(function (AlliancesActions) {
    AlliancesActions["getState"] = "[AlliancesGet] Get state";
    AlliancesActions["setSession"] = "[AlliancesSet] Set session";
    AlliancesActions["setContext"] = "[AlliancesSetContext] Set context";
    AlliancesActions["setIsLogin"] = "[AlliancesSetIsLogin] Set isLogin";
    AlliancesActions["setAlly"] = "[AlliancesSetAlly] Set ally";
    AlliancesActions["errSession"] = "[AlliancesError] Error session";
    AlliancesActions["logOutSession"] = "[AlliancesError] Logout session";
    AlliancesActions["loading"] = "[AlliancesLoading] set loading";
})(AlliancesActions || (AlliancesActions = {}));
class GetStateAction {
    constructor() {
        this.type = AlliancesActions.getState;
    }
}
class SetSessionAction {
    constructor(alliancesState) {
        this.alliancesState = alliancesState;
        this.type = AlliancesActions.setSession;
    }
}
class SetIsLoginAction {
    constructor(islogin) {
        this.islogin = islogin;
        this.type = AlliancesActions.setIsLogin;
    }
}
class SetErrorSessionAction {
    constructor(alliancesError) {
        this.alliancesError = alliancesError;
        this.type = AlliancesActions.errSession;
    }
}
class LogOutSessionAction {
    constructor() {
        this.type = AlliancesActions.logOutSession;
    }
}
class SetContextAction {
    constructor(context) {
        this.context = context;
        this.type = AlliancesActions.setContext;
    }
}
class SetAllyAction {
    constructor(ally) {
        this.ally = ally;
        this.type = AlliancesActions.setAlly;
    }
}
class SetLoadingAction {
    constructor(state) {
        this.state = state;
        this.type = AlliancesActions.loading;
    }
}

/**
 * @export
 * @class CookieService
 * @template T
 */
class CookieService {
    constructor() { }
    /**
     * @param {string} str
     * @returns {*}
     * @memberof CookieService
     */
    mapObject(str) {
        const obj = new Object();
        if (!this.isJson(str)) {
            return str;
        }
        const json = str ? JSON.parse(str) : null;
        if (!json) {
            return null;
        }
        for (const key in json) {
            if (json.hasOwnProperty(key)) {
                obj[key] = json[key];
            }
        }
        return obj;
    }
    /**
     *
     * @param {string} name
     * @returns {(T | string)}
     * @memberof CookieService
     */
    getCookie(name) {
        const cookieString = this.getBrowserCookie(name);
        return this.mapObject(cookieString);
    }
    /**
     *
     * @param {string} cname
     * @param {string} cvalue
     * @param {number} exdays
     * @memberof CookieService
     */
    setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
        const expires = 'expires=' + d.toUTCString();
        document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    }
    /**
     *
     * @private
     * @param {string} name
     * @returns {string}
     * @memberof CookieService
     */
    getBrowserCookie(name) {
        const cname = name + '=';
        const decodedCookie = decodeURIComponent(document.cookie);
        const ca = decodedCookie.split(';');
        for (let c of ca) {
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(cname) === 0) {
                return c.substring(cname.length, c.length);
            }
        }
        return null;
    }
    /**
     *
     * @param {string} name
     * @memberof CookieService
     */
    deleteCookie(name) {
        document.cookie = name + '=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }
    /**
     *
     * @param {string} str
     * @returns
     * @memberof CookieService
     */
    isJson(str) {
        try {
            JSON.parse(str);
        }
        catch (e) {
            return false;
        }
        return true;
    }
}
CookieService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: CookieService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
CookieService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: CookieService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: CookieService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return []; } });

const AppContext = window._app_context;

const esCO = {
    500: 'Ha ocurrido un erro y tu peticion no pudo ser completada,  Por favor intentalo de nuevo.',
    401: 'Tu sesion ha caducado debes ingresar de nuevo.',
    409: 'La petición no se pudo completar porque hubo un problema con ella, Por favor intentalo de nuevo.'
};

const esAR = {
    500: 'Ha ocurrido un erro y tu peticion no pudo ser completada, Por favor intentalo de nuevo.',
    401: 'Tu sesion ha caducado debes ingresar de nuevo.',
    409: 'La petición no se pudo completar porque hubo un problema con ella, Por favor intentalo de nuevo.'
};

class FactoryError {
    constructor(context) {
        this.context = context ||
            { locale: 'es_AR', brand: 'almundo', channel: '', country: 'ar', env: null, language: 'es', page: '', site: '' };
    }
    getErrorMessage(code = 500) {
        switch (this.context.locale) {
            case 'es_CO':
                return esCO[code] || esAR[500];
            case 'es_AR':
                return esAR[code] || esAR[500];
            default:
                return esAR[code] || esAR[500];
        }
    }
}

/**
 *
 *
 * @export
 * @class AlliancesServicesService
 */
class AlliancesServicesService {
    /**
     * Creates an instance of AlliancesServicesService.
     * @param {*} URL_API
     * @param {HttpClient} http
     * @param {Store<AppState>} store
     * @param {CookieService<string>} service
     * @memberof AlliancesServicesService
     */
    constructor(URL_API, context, http, store, service) {
        this.http = http;
        this.store = store;
        this.service = service;
        this.TYPES_BRANDS = BRANDS;
        this.requestStateSession = false;
        this.key = 'id_token';
        this.URL_API = URL_API;
        this.getAllianceSession = this.getAllianceSession.bind(this);
        this.context = this.preparedContext(context);
        this.setContexteState(this.context);
    }
    preparedContext(context = AppContext) {
        return {
            ...context,
            brand: context.brand ? context.brand.toLowerCase() : '',
            channel: context.channel ? context.channel.toLowerCase() : '',
            locale: context.locale ? context.locale : '',
            country: context.country ? context.country : '',
            language: context.language ? context.language : '',
            page: context.page ? context.page.toLowerCase() : '',
            site: context.site ? context.site.toLowerCase() : ''
        };
    }
    /**
     * @param {string} idSession
     * @returns {Observable<AllianceMenuItem[]>}
     */
    getAllianceMenuItems(idSession) {
        return this.http
            .get(`${this.URL_API}/ntpm/srio/${idSession}/menu/items/`)
            .pipe(catchError(this.handleError('getAllianceMenuItems')));
    }
    /**
     * @param {string} idSession
     * @returns {Observable<boolean>}
     */
    allianceLogOut(brand) {
        const headers = this.addAuthorizationHeader();
        return this.http
            .get(`${this.URL_API}/ntpm/alliance/${brand}/logout`, headers)
            .pipe(tap(this.deleteCookie), catchError(err => {
            this.deleteCookie();
            throw err;
        }));
    }
    deleteCookie() {
        this.service.deleteCookie('id_token');
        this.store.dispatch(new LogOutSessionAction());
    }
    /**
     * @returns {Observable<RewardSession>}
     */
    async getAllianceSession() {
        const alliance = await this.validateBrandGetAlliance(this.context).toPromise();
        if (!alliance) {
            return null;
        }
        const token = this.getToken();
        if (!token) {
            return null;
        }
        if (!this.requestStateSession) {
            this.requestStateSession = true;
            const headers = this.addAuthorizationHeader();
            const url = `${this.URL_API}/ntpm/alliance/${this.context ? this.context.brand : 'superclub'}/session?id_token=${token}`;
            return this.http.get(url, headers).pipe(map(res => {
                this.store.dispatch(new SetLoadingAction(false));
                return this.setAllianceSession(res);
            }), catchError(err => this.catchErrorAllianceSession(err, true))).toPromise();
        }
        return null;
    }
    /**
     * @returns {string}
     */
    getToken() {
        const id = this.service.getCookie(this.key);
        if (!id) {
            this.store.dispatch(new SetIsLoginAction(false));
            return null;
        }
        return id;
    }
    /**
     * @param {RewardSession} rewardSession
     * @returns {RewardSession}
     * @memberof AlliancesServicesService
     */
    setAllianceSession(rewardSession) {
        this.store.dispatch(new SetIsLoginAction(!!rewardSession));
        this.store.dispatch(new SetSessionAction({ error: null, rewardSession }));
        this.requestStateSession = false;
        return rewardSession;
    }
    /**
     * @param err
     * @returns
     * @memberof AlliancesServicesService
     */
    catchErrorAllianceSession(err, logout = false) {
        const error = this.getError(err);
        const action = new SetErrorSessionAction(error);
        this.store.dispatch(action);
        this.handleError('catchErrorAllianceSession');
        this.requestStateSession = false;
        this.store.dispatch(new SetLoadingAction(false));
        this.service.deleteCookie('id_token');
        return throwError(error);
    }
    getError(err) {
        const error = err.error;
        if (error && error.error) {
            const msg = new FactoryError(this.context).getErrorMessage(error.code);
            return new AlliancesError()
                .builder()
                .code(err.code)
                .messages(msg)
                .stackTrace(error.error.stack_trace)
                .status(err.status)
                .build();
        }
        const message = new FactoryError(this.context).getErrorMessage(err.code);
        return new AlliancesError()
            .builder()
            .code(err.code)
            .messages(message)
            .stackTrace(err.stack_trace)
            .status(err.status)
            .build();
    }
    /**
     * @param {ProductsSession} productsSession
     * @returns {Observable<AvailabilityRewards>}
     * @memberof AlliancesServicesService
     */
    getPriceAndTaxes(productsSession) {
        const headers = this.addAuthorizationHeader();
        const url = `${this.URL_API}/ntpm/getPriceAndTaxes`;
        return this.http
            .post(url, productsSession, headers)
            .pipe(catchError(this.handleError('getPriceAndTaxes')));
    }
    /**
     * @param {string} operation
     * @returns
     * @memberof AlliancesServicesService
     */
    handleError(operation) {
        return (err) => {
            const errMsg = `error in ${operation}() retrieving ${this.URL_API}`;
            if (err instanceof HttpErrorResponse) {
                console.log(`status: ${err.status}, ${err.statusText}`);
            }
            return throwError(errMsg);
        };
    }
    /**
     * @param {number} sliderPoints
     * @param {number} allSliderPoints
     * @param {number} sliderMaxValue
     * @param {number} [sliderMinValue=0]
     * @param {number} productsPrice
     * @param {number} productTaxes
     * @param {actionEnum} [sliderAction=actionEnum.reduce]
     * @returns {number}
     * @memberof AlliancesServicesService
     */
    validatePoints(sliderPoints, allSliderPoints, sliderMaxValue, sliderMinValue = 0, productsPrice, productTaxes, sliderAction = actionEnum.reduce) {
        sliderPoints =
            sliderPoints > allSliderPoints ? allSliderPoints : sliderPoints;
        if (sliderPoints < sliderMinValue) {
            sliderPoints = sliderMinValue;
        }
        if (sliderPoints > sliderMaxValue) {
            sliderPoints = sliderMaxValue;
        }
        if (!productsPrice) {
            return sliderPoints;
        }
        if (sliderPoints < productsPrice) {
            return sliderPoints;
        }
        if (productTaxes > 0) {
            if (sliderPoints >= productsPrice + productTaxes) {
                return productsPrice + productTaxes;
            }
            if (sliderPoints > productsPrice && sliderAction === actionEnum.reduce) {
                return productsPrice;
            }
            if (sliderPoints < productsPrice + productTaxes &&
                sliderAction === actionEnum.add) {
                return productsPrice + productTaxes;
            }
        }
        return productsPrice;
    }
    /**
     * @param {Context} context
     * @memberof AlliancesServicesService
     */
    setContexteState(context) {
        const action = new SetContextAction(context);
        this.store.dispatch(action);
        this.getAllianceSession();
    }
    /**
     * @param {Context} context
     * @returns {Ally}
     */
    validateBrandGetAlliance(context) {
        if (!context) {
            return of(null);
        }
        if (!(context.brand.toLocaleUpperCase() in this.TYPES_BRANDS)) {
            return of(null);
        }
        this.store.dispatch(new SetLoadingAction(true));
        return this.setAllyState().pipe(tap(res => this.store.dispatch(new SetAllyAction(res))));
    }
    /**
     * @memberof AlliancesServicesService
     */
    setAllyState() {
        const url = `${this.URL_API}/ntpm/alliance/${this.context ? this.context.brand : 'superclub'}/setting`;
        return this.http
            .get(url)
            .pipe(catchError(err => this.catchErrorAllianceSession(err)));
    }
    addAuthorizationHeader() {
        const header = { headers: null };
        const token = this.service.getCookie('id_token');
        if (!!token) {
            header.headers = new HttpHeaders().set('Authorization', `Bearer ${token || ''}`);
        }
        return header;
    }
}
AlliancesServicesService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AlliancesServicesService, deps: [{ token: 'BASE_URL_NTPM' }, { token: 'APP_CONTEXT_TOKEN' }, { token: i1.HttpClient }, { token: i2.Store }, { token: CookieService }], target: i0.ɵɵFactoryTarget.Injectable });
AlliancesServicesService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AlliancesServicesService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AlliancesServicesService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: ['BASE_URL_NTPM']
                }] }, { type: undefined, decorators: [{
                    type: Inject,
                    args: ['APP_CONTEXT_TOKEN']
                }] }, { type: i1.HttpClient }, { type: i2.Store }, { type: CookieService }]; } });

const initialState = {
    rewardSession: null,
    error: null,
    context: null,
    ally: null,
    isLogin: true,
    loading: true
};
function alliancesReducer(state = initialState, action) {
    if (!action) {
        return state;
    }
    switch (action.type) {
        case AlliancesActions.getState:
            return state;
        case AlliancesActions.setSession:
            return { ...state, ...action.alliancesState };
        case AlliancesActions.errSession:
            return { ...state, error: action.alliancesError };
        case AlliancesActions.logOutSession:
            return { ...state, error: null, rewardSession: null, isLogin: false };
        case AlliancesActions.setIsLogin:
            return { ...state, isLogin: action.islogin };
        case AlliancesActions.setContext:
            return { ...state, context: action.context };
        case AlliancesActions.setAlly:
            return { ...state, ally: action.ally };
        case AlliancesActions.loading:
            return { ...state, loading: action.state };
        default:
            return state;
    }
}

const storeName = 'alliances';

class AlliancesServicesModule {
    constructor() { }
    static forRoot(config) {
        return {
            ngModule: AlliancesServicesModule,
            providers: [
                {
                    provide: 'BASE_URL_NTPM',
                    useValue: config.url
                },
                {
                    provide: 'APP_CONTEXT_TOKEN',
                    useValue: config.context
                }
            ]
        };
    }
}
AlliancesServicesModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AlliancesServicesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
AlliancesServicesModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "15.2.10", ngImport: i0, type: AlliancesServicesModule, imports: [CommonModule,
        HttpClientModule, i2.StoreFeatureModule, i2$1.StoreDevtoolsModule] });
AlliancesServicesModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AlliancesServicesModule, imports: [CommonModule,
        HttpClientModule,
        StoreModule.forFeature(storeName, alliancesReducer),
        StoreDevtoolsModule.instrument({
            maxAge: 25,
            logOnly: true
        })] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "15.2.10", ngImport: i0, type: AlliancesServicesModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        CommonModule,
                        HttpClientModule,
                        StoreModule.forFeature(storeName, alliancesReducer),
                        StoreDevtoolsModule.instrument({
                            maxAge: 25,
                            logOnly: true
                        })
                    ]
                }]
        }], ctorParameters: function () { return []; } });

const selectAlliancesRewardSessionState = createSelector((state) => state.alliances, (state) => state.rewardSession);
const selectAlliancesAllyState = createSelector((state) => state.alliances, (state) => state.ally);
const selectAlliancesContextState = createSelector((state) => state.alliances, (state) => state.context);

/*
 * Public API Surface of alliances-services
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AllianceMenuItem, AlliancesActions, AlliancesError, AlliancesServicesModule, AlliancesServicesService, AvailabilityRewards, BRANDS, Base, CONVERSION_TYPES, ComponentErrorHandler, Conversion, CookieService, CreditsRewards, Environment, GetStateAction, LogOutSessionAction, PriceRewards, Product, ProductTypes, Products, ProductsSession, Reward, RewardSession, RewardSessionServer, SITES, SetAllyAction, SetContextAction, SetErrorSessionAction, SetIsLoginAction, SetLoadingAction, SetSessionAction, Site, Slider, Source, TaxesRewards, actionEnum, alliancesReducer, initialState, selectAlliancesAllyState, selectAlliancesContextState, selectAlliancesRewardSessionState };
